var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.8885 20.4091L32 0L22.1115 20.4091L0 23.6819L16 39.5682L12.2229 62L32 51.4091L51.7771 62L48 39.5682L64 23.6819L41.8885 20.4091ZM55.5152 26.4696L39.2109 24.0564L32 9.17366L24.7891 24.0564L8.48481 26.4696L20.2885 38.1894L17.521 54.6254L32 46.8717L46.479 54.6254L43.7115 38.1894L55.5152 26.4696Z",
    fill: "#006DF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3711 20.6289L39.8489 24.1512L55.5149 26.4699L43.7113 38.1897L46.4788 54.6257L31.9997 46.872L17.5207 54.6257L19.1701 44.8299L14.2925 49.7075L12.2227 62.0003L31.9997 51.4094L51.7768 62.0003L47.9997 39.5685L63.9997 23.6822L43.3711 20.6289Z",
    fill: "#006DF0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStar);
export default __webpack_public_path__ + "static/media/icon-star.cd3933c35cd16e51e8d1079d9e78fc8e.svg";
export { ForwardRef as ReactComponent };